import moment from 'moment'


export default function changeDateFormat(date, currentFormat = 'YYYY-MM-DD', nextFormat = 'DD.MM.YYYY') {
  return date ? moment(date, currentFormat).format(nextFormat) : undefined
}
